import {
    SegmentEntityType,
    ViewRow,
    WpDisplayConfig,
    WpViewTable,
} from '../../core';
import { Row } from '../../grid';
import { TranslationKeyMap } from '../main.i18n';
import { RowValues } from '../model/row-values.model';

export function setRowExpanded(r: Row, isExpanded: boolean): void {
    const expandIcon = isExpanded ? 'chevron-down' : 'chevron-right';
    const expandIconTooltip = isExpanded
        ? TranslationKeyMap._10092_COLLAPSE_ROW
        : TranslationKeyMap._10091_EXPAND_ROW;
    r.ctx.values.isExpanded = isExpanded;
    r.ctx.values.expandIcon = expandIcon;
    r.ctx.values.expandIconTooltip = expandIconTooltip;
}

export function createRowValues(
    r: ViewRow,
    table: WpViewTable,
    config: WpDisplayConfig,
): RowValues {
    const drillPath = config.drillPaths.find(
        (e) => e.identifier === table.drillPathIdentifier,
    );
    const segment = drillPath?.segments?.find(
        (e) => e.identifier === r.segmentIdentifier,
    );

    const canExpand =
        drillPath?.segments?.indexOf(segment) !==
        drillPath?.segments?.length - 1;
    const indentPx = segment.index * 20 + (!canExpand ? 24 : 0);
    const showUserIcon =
        segment.entityType === SegmentEntityType.USER ||
        segment.entityType === SegmentEntityType.DIRECT_REPORT;

    let managerMatchesCurrentManager = true;
    if (
        segment.entityType === SegmentEntityType.USER ||
        segment.entityType === SegmentEntityType.DIRECT_REPORT
    ) {
        managerMatchesCurrentManager =
            r.manager?.userId === r.currentManager?.userId;
    }

    let label: string | null = null;
    switch (segment.entityType) {
        case SegmentEntityType.USER:
        case SegmentEntityType.DIRECT_REPORT:
            label = `${r.user?.firstName?.trim() ?? ''} ${
                r.user?.lastName?.trim() ?? ''
            }`;
            break;
        case SegmentEntityType.METRIC:
            label = r.metric?.fullName?.trim();
            break;
        case SegmentEntityType.BEHAVIOUR:
            label = r.behaviour?.name?.trim();
            break;
        case SegmentEntityType.SUB_BEHAVIOUR:
            label = r.subBehaviour?.name?.trim();
            break;
    }
    let labelTooltip: string | null = label;
    let showLabelTooltip = false;
    if (
        segment.entityType !== SegmentEntityType.USER &&
        segment.entityType !== SegmentEntityType.DIRECT_REPORT &&
        label?.length > 50
    ) {
        labelTooltip = label;
        label = `${label?.slice(0, 47) ?? ''}...`;
        showLabelTooltip = true;
    }

    return {
        canExpand,
        indentPx,
        expandIcon: null,
        expandIconTooltip: null,
        showUserIcon,
        managerMatchesCurrentManager,
        label,
        labelTooltip,
        showLabelTooltip,
        total: r.row.individual?.total ?? r.row.peopleDetail?.total,
        winningPercentage:
            r.row.individual?.winning ?? r.row.peopleDetail?.winning,
        winningNumber:
            r.row.individual?.winningNumber ??
            r.row.peopleDetail?.winningNumber,
        neutralPercentage:
            r.row.individual?.neutral ?? r.row.peopleDetail?.neutral,
        neutralNumber:
            r.row.individual?.neutralNumber ??
            r.row.peopleDetail?.neutralNumber,
        losingPercentage:
            r.row.individual?.losing ?? r.row.peopleDetail?.losing,
        losingNumber:
            r.row.individual?.losingNumber ?? r.row.peopleDetail?.losingNumber,
        winningThresholdColour:
            r.row.individual?.winningThresholdColour ??
            r.row.peopleDetail?.winningThresholdColour,
    };
}
